// extracted by mini-css-extract-plugin
module.exports = {"wrap":"page_copy-module--wrap--c8o2D","letter":"page_copy-module--letter--3WNSy"};